import {Button, Grid, Paper, Stack, TextField, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {useTheftMisappropriationActions} from "../../../../service/useTheftMisappropriationActions";
import {setSnackbar} from "../../../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../../../util/state/globalVariables";
import {GlobalContext} from "../../../../../../util/state/GlobalContextProvider";
import dayjs from "dayjs";
import EmptyState from "../../../../../../util/component/EmptyState";
import {useHasScope} from "../../../../../../config/globalConfig";
import {
    THEFT_MISAPPROPRIATION_SCOPE_EDIT,
    THEFT_MISAPPROPRIATION_SCOPE_EDIT_STATE
} from "../../../../component/utils/AuthConstants";

const TabActivity = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const {id} = useParams();
    const [activityNote, setActivityNote] = useState("");
    const [activities, setActivities] = useState([]);
    const hasScope = useHasScope;
    const {addActivity, getActivities} = useTheftMisappropriationActions();
    const {dispatchGlobalData} = useContext(GlobalContext);

    useEffect(() => {
        getAllActivities();
    }, [])

    function getAllActivities() {
        getActivities(id).then(res => {
            if (res.result) {
                setActivities(res.result);
            }
        })
    }

    function onChangeActivity(e: any) {
        setActivityNote(e.target.value);
    }

    const onAddActivity = () => {
        let payload = {activity: activityNote}
        addActivity(payload, id).then(data => {
            if (data && data.status === "OK") {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t("updateForm.updateMessage"),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
                setActivityNote("");
                getAllActivities();
            } else {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t("updateForm.updateError"),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            }
        });

    }

    return (


        <Grid container>
            <Grid item container xs={12} sx={{paddingTop: "10px"}}>
                <Grid item xs={12}>
                    <TextField
                        label={t("tabs.activity")}
                        fullWidth
                        multiline
                        rows={4}
                        variant={"outlined"}
                        type="text"
                        value={activityNote}
                        placeholder={t("activity.writeComment")}
                        onChange={onChangeActivity}
                        disabled={!hasScope(THEFT_MISAPPROPRIATION_SCOPE_EDIT)}
                    />
                </Grid>

                <Grid container item xs={12} sx={{paddingTop: "10px"}} justifyContent={"flex-end"}>
                    <Grid item>
                        {hasScope(THEFT_MISAPPROPRIATION_SCOPE_EDIT) &&
                            <Button onClick={onAddActivity}>
                            {t('buttons.save')}
                        </Button>}
                    </Grid>
                </Grid>
            </Grid>
            <Grid xs={12} item container justifyContent={"center"} sx={{paddingTop: "25px"}}>
                <Grid item xs={12}>
                    <Paper elevation={3} style={{minHeight: "190px"}}>
                        <Grid item container xs={12} justifyContent={"center"} sx={{padding: "16px 16px 0 16px"}}>
                            {activities.length > 0 ?
                                activities.map((act: any) => (
                                    <Grid item container xs={12} sx={{paddingBottom: "16px"}}>
                                        <Paper elevation={2}
                                               sx={{width: "100%", backgroundColor: "#FAFBFF"}}>
                                            <Grid item container xs={12} sx={{padding: "10px"}}>
                                                <Grid item container xs={12} justifyContent={"flex-end"}>
                                                    <Stack direction={"row"} alignItems={"center"}>
                                                        <Typography fontFamily={"Tahoma"} fontStyle={"normal"}
                                                                    fontWeight={"700"} fontSize={"16px"}
                                                                    lineHeight={"140%"}
                                                                    letterSpacing={"-0.01em"}>{dayjs(act.createDatetime).format("lll")}</Typography>
                                                    </Stack>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Stack
                                                        direction="row"
                                                        justifyContent="flex-start"
                                                        alignItems="center"
                                                        spacing={2}
                                                    >
                                                        <Typography style={{width: "70px"}} fontFamily={"Raleway"}
                                                                    fontStyle={"normal"}
                                                                    fontWeight={"500"} fontSize={"16px"}
                                                                    lineHeight={"140%"}
                                                                    letterSpacing={"-0.01em"}
                                                                    display="inline">{t("activity.operator") + ": "}</Typography>
                                                        <Typography fontFamily={"Raleway"} fontStyle={"normal"}
                                                                    fontWeight={"700"} fontSize={"16px"}
                                                                    lineHeight={"140%"}
                                                                    letterSpacing={"-0.01em"}
                                                                    display="inline">{act.entryUser}</Typography>
                                                    </Stack>
                                                </Grid>
                                                <Grid item xs={12} sx={{paddingTop: "5px"}}>
                                                    <Typography fontFamily={"Tahoma"} fontStyle={"normal"}
                                                                fontWeight={"400"} fontSize={"16px"}
                                                                lineHeight={"190%"}
                                                                style={{opacity: "0.6"}}>{act.activity}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>))
                                :
                                <Grid item xs={3} paddingTop={5}>
                                    <EmptyState title={t("activity.noActivitiesTitle")}
                                                content={t("activity.noActivitiesDescription")}/>
                                </Grid>
                            }</Grid>
                    </Paper>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default TabActivity;